import { useSelector } from 'react-redux';
import { UserType } from '@gumtree/shell/src/reducers/common/user-type';
import { BaseConfigState } from '@gumtree/shell/src/reducers/common/base-config';

export function useUserType() {
    // Avoid some pages not returning usertype in model and hydration problems
    const { cookieUserType, modelUserType } = useSelector(
        ({ baseConfig, userType }: { baseConfig: BaseConfigState; userType: UserType }) => ({
            cookieUserType: baseConfig?.userType,
            modelUserType: userType,
        })
    );
    
    return cookieUserType || modelUserType || 'STANDARD';
}
